import { render, staticRenderFns } from "./RedemptionOfOrnament.vue?vue&type=template&id=33020d13&"
import script from "./RedemptionOfOrnament.vue?vue&type=script&lang=js&"
export * from "./RedemptionOfOrnament.vue?vue&type=script&lang=js&"
import style0 from "./RedemptionOfOrnament.vue?vue&type=style&index=0&id=33020d13&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports